import React, { useState } from 'react';
import styled from 'styled-components';
import { supabase } from './supabaseClient';

const PageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 56px);
    background-color: #f8fafc;
    padding: 20px;
`;

const FormCard = styled.div`
    background: #ffffff;
    border-radius: 16px;
    padding: 40px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    text-align: center;
`;

const Title = styled.h2`
    color: #00205B;
    font-size: 1.75rem;
    font-weight: 700;
    margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
    color: #64748b;
    font-size: 0.95rem;
    margin: 0 0 32px 0;
`;

const GoogleButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    padding: 14px;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    font-family: 'Roboto', sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #334155;

    &:hover {
        border-color: #00205B;
        background: #f8fafc;
    }

    &:active {
        transform: scale(0.98);
    }
`;

const GoogleIcon = styled.span`
    font-size: 1.2rem;
`;

const ErrorMessage = styled.p`
    color: #dc2626;
    font-size: 0.85rem;
    margin: 0 0 16px 0;
`;

const HintText = styled.p`
    color: #94a3b8;
    font-size: 0.8rem;
    margin: 16px 0 0 0;
`;

const Login: React.FC = () => {
    const [error, setError] = useState('');

    const handleGoogleLogin = async () => {
        setError('');
        const { error: authError } = await supabase.auth.signInWithOAuth({
            provider: 'google',
            options: {
                queryParams: {
                    hd: 'rice.edu',
                },
                redirectTo: window.location.origin,
            },
        });

        if (authError) {
            setError(authError.message);
        }
    };

    return (
        <PageContainer>
            <FormCard>
                <Title>Welcome to Rice Exams</Title>
                <Subtitle>Sign in with your Rice Google account</Subtitle>
                {error && <ErrorMessage>{error}</ErrorMessage>}
                <GoogleButton onClick={handleGoogleLogin}>
                    <GoogleIcon>G</GoogleIcon>
                    Sign in with Google
                </GoogleButton>
                <HintText>Use your @rice.edu Google account</HintText>
            </FormCard>
        </PageContainer>
    );
};

export default Login;
